// App.js
// PrizeReal — Ensamblado final

import React, { useCallback } from "react";
import useAuth from "./hooks/useAuth";

import "./components/theme.css";

// Pantallas
import LoadingScreen  from "./screens/LoadingScreen";
import LoginScreen    from "./screens/LoginScreen";
import HomeScreen     from "./screens/HomeScreen";
import ShareScreen    from "./screens/ShareScreen";
import ClaimScreen    from "./screens/ClaimScreen";
import SuccessScreen  from "./screens/SuccessScreen";
import LevelsScreen   from "./screens/LevelsScreen";
import PlansScreen    from "./screens/PlansScreen";
import ProfileScreen  from "./screens/ProfileScreen";
import DisputeScreen  from "./screens/DisputeScreen";

import NavBar from "./components/NavBar";

const NAV_SCREENS = ["home", "levels", "profile"];

const App = () => {
  const auth = useAuth();

  const [screen, setScreen] = React.useState("home");
  const [params, setParams] = React.useState({});
  const [prevScreen, setPrevScreen] = React.useState(null);
  const [prevParams, setPrevParams] = React.useState({});

  const navigate = useCallback((nextScreen, nextParams = {}) => {
    setPrevScreen(screen);
    setPrevParams(params);
    setScreen(nextScreen);
    setParams(nextParams);
  }, [screen, params]);

  const goBack = useCallback(() => {
    if (prevScreen) {
      setScreen(prevScreen);
      setParams(prevParams);
      setPrevScreen(null);
      setPrevParams({});
    } else {
      setScreen("home");
      setParams({});
    }
  }, [prevScreen, prevParams]);

  if (auth.loading) return <LoadingScreen />;
  if (!auth.isLoggedIn) return <LoginScreen authHook={auth} />;
  if (!auth.phoneVerified) return <LoginScreen authHook={auth} />;

  const showNavBar = NAV_SCREENS.includes(screen);

  return (
    <div className="app">
      <main className="app__main">

        {screen === "home" && (
          <HomeScreen authHook={auth} onNavigate={navigate} />
        )}

        {screen === "share" && (
          <ShareScreen
            business={params.business}
            authHook={auth}
            onBack={goBack}
          />
        )}

        {screen === "claim" && (
          <ClaimScreen
            business={params.business}
            authHook={auth}
            onSuccess={(redemption) =>
              navigate("success", { redemption, business: params.business })
            }
            onBack={goBack}
          />
        )}

        {screen === "success" && (
          <SuccessScreen
            redemption={params.redemption}
            business={params.business}
            authHook={auth}
            onHome={() => navigate("home")}
            onDispute={() =>
              navigate("dispute", {
                redemption: params.redemption,
                business:   params.business,
              })
            }
          />
        )}

        {screen === "levels" && (
          <LevelsScreen authHook={auth} />
        )}

        {screen === "plans" && (
          <PlansScreen authHook={auth} onBack={goBack} />
        )}

        {screen === "profile" && (
          <ProfileScreen authHook={auth} onNavigate={navigate} />
        )}

        {screen === "dispute" && (
          <DisputeScreen
            redemption={params.redemption}
            business={params.business}
            authHook={auth}
            onBack={goBack}
          />
        )}

      </main>

      {showNavBar && (
        <NavBar
          activeScreen={screen}
          onNavigate={(s) => navigate(s)}
        />
      )}
    </div>
  );
};

export default App;